import { FunctionComponent } from 'react'
import { Grid } from '@material-ui/core'

import { colors } from 'shared/styles/colors'
import Button from 'shared/components/Button'
import { StyledModal, Text, Title } from './styles'

interface ModalTermosProp {
  openModal: boolean
  setOpenModal()
  termos: string
}
const ModalTermos: FunctionComponent<ModalTermosProp> = ({
  openModal,
  setOpenModal,
  termos,
}) => {
  return (
    <StyledModal
      openModal={openModal}
      size="unset"
      margin="auto"
      showCloseButton={true}
      onCloseModal={setOpenModal}
      title="Termos de uso"
      showCloseButtonBottom={true}
      overflowY="auto"
    >
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        style={{ padding: 16 }}
      >
        <Text dangerouslySetInnerHTML={{ __html: termos }} />
      </Grid>
    </StyledModal>
  )
}

export default ModalTermos
